import { DataTypes } from "../../../Common/Data/DataTypes";
import { BaseJSONXMLElement } from "./BaseJSONXMLElement";

export class JSONXMLDateElement extends BaseJSONXMLElement {
    readonly __type: string = "jsondate";
    readonly name: string = "Date Value";
    readonly ordinal: number = 3;
    readonly outputType: DataTypes = DataTypes.DATE;
    readonly styleElement: boolean = false;
}
